<template>
<!-- Novo component para fazer download de aquivos tela  aba Formulario e Declaraçoes-->
  <div >
    <v-text-field cols12 sm6 md3
      v-model.lazy="valor"
      :readonly="true"
      clearable
      :label="label"
      append-icon="get_app"
      @click:append="baixarArquivo(codDocumento)"
      :rules="rules ? rules : []"
      :hint="hint"
    ></v-text-field> 
  </div>  
  
</template>
<script>

import fornecedorService from "../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
export default {
  name: "textFieldDeclaracoesArquivos",
 
 
  components: { /*Componentes utilizados*/
  },
  props: {//Propriedades que o objeto recebe como parametro
    arquivoUpload: String,
    idFornecedor: String,
    arquivoUploadSituacao: Number,
    codDocumento: String, 
    label: String,
    rules: Array,
    hint: String,
    "persistent-hint": Boolean, 
    valuer: Number
  },

  watch: { //Propriedades assistidas
    arquivoUpload: {
      handler(newValue) { /*Se houver um novo valor*/
        if (newValue) {
          this.valor = this.subStrUpload(this.arquivoUpload.codDocumento);
        }
      }
    },
  },

  data() {//Declaracao de variaveis
    return {
        valor:""
    };
  },

  methods: {
    baixarArquivo(codDocumento) {//fazer o metodo estatico para baixar os arquivos do ComprasNet
      // fornecedorService.baixarArquivo(this.arquivoUpload, this.idFornecedor);
      
      if(codDocumento==64){// Documentação Declaração do Empregador:
        window.open("https://www.comprasnet.ba.gov.br/sites/default/files/declaracao_empregador_lici.pdf",'_blank');
      }
      if(codDocumento==71){// Documento Declaração de Superveniência:
        window.open("https://www.comprasnet.ba.gov.br/sites/default/files/declaracao_superveniencia_l.pdf",'_blank');
      }
      if(codDocumento==99){//Ducumento Declaração de Enquadramento:
        window.open("https://www.comprasnet.ba.gov.br/sites/default/files/modelo_declaracao_enquadramento.pdf",'_blank');
      }
      if(codDocumento==100){//Ducumento Declaração de Desenquadramento:
        window.open("https://www.comprasnet.ba.gov.br/sites/default/files/declaracao_de_desenquadramento.pdf",'_blank');
      }
    },
    subStrUpload(str) {
      var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;

      //Se for link
      if(regex .test(str)) {
        return  str.substring(0,35)+'...';
      }

      return str != null ? str.substring(str.indexOf("_") + 1) : str;
    },
  }
};
</script>

<style>
.input-aprovado .v-input__prepend-outer,
.input-aprovado .v-input__icon,
.input-aprovado .v-text-field__slot,
.input-aprovado .v-input__prepend-inner,
.input-aprovado .v-input__icon--prepend-inner,
.input-aprovado .v-input__slot,
.input-aprovado .v-input__slot::before {
  border-color: #4caf50 !important;
}

.input-rejeitado .v-input__prepend-outer,
.input-rejeitado .v-input__icon,
.input-rejeitado .v-text-field__slot,
.input-rejeitado .v-input__prepend-inner,
.input-rejeitado .v-input__icon--prepend-inner,
.input-rejeitado .v-input__slot,
.input-rejeitado .v-input__slot::before {
  border-color: #ff5252 !important;
}

</style>